import React from "react";
import { Link } from "react-router-dom";
import { Icon } from "antd";
import moment from "moment";

import {
    iconVideo,
    iconAudio,
    iconHtml,
    iconPdf,
    iconQuestionario,
    iconAvaliacao,
    iconDownload,
    iconTrabalhoIndividual,
    iconTrabalhoGrupo,
    iconTrabalhoColaborativo,
    iconLink,
    iconSumario,
    iconSessaoPresencial,
    iconPasta,
    iconQuestionarioProgresso,
    iconQuestionarioDirigido,
    iconPresencas
} from "../../../../../../../assets/tipoDeConteudos";

import styles from "./Tarefa.module.scss";

const iconesPorTipo = {
    1: { icon: iconVideo }, // Vídeo
    2: { icon: iconAudio }, // Áudio
    3: { icon: iconHtml }, // HTML
    12: { icon: iconHtml }, // HTML EMBEBIDO
    4: { icon: iconPdf }, // PDF
    5: { icon: iconQuestionario }, // QUESTIONÁRIO
    6: { icon: iconAvaliacao }, // AVALIAÇÃO
    7: { icon: iconDownload }, // DOWNLOAD
    8: {
        // Trabalho
        icon: aula => {
            switch (aula.tipo_trabalho) {
                case "INDIVIDUAL":
                    return iconTrabalhoIndividual;
                case "GRUPO":
                    return iconTrabalhoGrupo;
                default:
                    return iconTrabalhoColaborativo;
            }
        }
    },
    9: { icon: iconLink }, // LINK
    10: { icon: iconSumario }, // SUMÁRIO
    11: { icon: iconSessaoPresencial }, // SESSÃO PRESENCIAL
    13: { icon: iconPasta }, // PASTA
    14: { icon: iconQuestionarioProgresso }, // QUESTIONÁRIO DE PROGRESSO
    15: { icon: iconQuestionarioDirigido }, // QUESTIONÁRIO DIRIGIDO
    17: { icon: iconPresencas } // PRESENCAS
};

const Tarefa = ({ aula, inicioUrl, moduloIndex, validarDisponibilidade, inscrito, estado, modulo }) => {
    const { id, nome, tipo_Recurso, modulo_Aulas_Utilizadores: registoUtilizador, dt_inicio, dt_fim, hora, duracao } = aula;
    const { precendenciaId, precedencia, obrigatoria } = modulo;

    let url = `${inicioUrl}${tipo_Recurso.url}`;

    if (registoUtilizador?.periodo_onde_esta) url = `${url}?start=${registoUtilizador?.periodo_onde_esta}`;

    const tipoId = tipo_Recurso.id;
    const tipoConfig = iconesPorTipo[tipoId];

    if (!tipoConfig) return null;

    const icone = typeof tipoConfig.icon === "function" ? tipoConfig.icon(aula) : tipoConfig.icon;

    const onClick = aulaId => {
        localStorage.setItem("modulo_aberto", moduloIndex);
        localStorage.setItem("codigo_aula", aulaId);
    };

    const montarHoraTermino = (horaInicial, duracao) => {
        const hora = moment(horaInicial).add(duracao.hours(), "hours").add(duracao.minutes(), "minutes");
        return hora.format("HH:mm");
    };

    const tiposParaBloquear = [5, 6, 8, 15];

    const podeAceder = estado || (!estado && !tiposParaBloquear.includes(tipoId));

    const precedenciaValida =
        !precedencia || !obrigatoria || (obrigatoria && localStorage.getItem("estado_atividade_" + precendenciaId) === "true");

    const tarefaDesbloqueada = podeAceder && precedenciaValida;

    const dataInicioFormatada = dt_inicio && moment(dt_inicio).format("DD/MM/YYYY");
    const dataFimFormatada = dt_fim && moment(dt_fim).format("DD/MM/YYYY");

    const TarefaInformacao = (
        <>
            <span className={`start ${styles.icone}`} title={tipo_Recurso.nome}>
                <img className="tarefa-icon" src={icone} />
            </span>
            <span className="licao">
                {nome}
                {registoUtilizador?.marcador && (
                    <span className={`marcador ${styles.marcador}`}>
                        <i className="fas fa-bookmark" />
                    </span>
                )}
                {dataInicioFormatada && (
                    <span className="data-hora">
                        <strong title="Inicio do Trabalho">{dataInicioFormatada}</strong> até{" "}
                        <strong title="Data limite de entrega">{dataFimFormatada}</strong>
                    </span>
                )}
                {dataInicioFormatada && !dataFimFormatada && (
                    <span className="data-hora">
                        <strong title="Inicio do Trabalho">
                            {dataInicioFormatada}
                            {aula.hora && (
                                <>
                                    {" "}
                                    <i className="fas fa-circle separador-data-hora"></i> {hora} -{" "}
                                    {montarHoraTermino(moment(hora, "HH:mm"), moment(duracao, "HH:mm"))}
                                </>
                            )}
                        </strong>
                    </span>
                )}
                {!dataInicioFormatada && dataFimFormatada && (
                    <span className="data-hora">
                        <strong title="Data limite de entrega">Até {dataFimFormatada}</strong>
                    </span>
                )}
                {moment().isAfter(moment(aula.dt_fim)) && registoUtilizador?.concluido && (
                    <Icon type="warning" className="atrasado" title="Existe atraso na realização desta tarefa" />
                )}
            </span>
        </>
    );

    if (!tarefaDesbloqueada)
        return (
            <Link to="#" className={styles.bloqueada}>
                {TarefaInformacao}
            </Link>
        );

    return (
        <Link to={url} onClick={() => onClick(id)} disabled={validarDisponibilidade()}>
            {TarefaInformacao}
        </Link>
    );
};

export default Tarefa;
